import React, { useState, useEffect, useRef } from 'react';
import validator from 'validator';
import { constBreadCrumbsTitle } from 'utility';
import {
  Grid,
  Button,
  RadioGroup,
  Radio,
  FormControlLabel,
  Typography,
  Checkbox,
  Box,
} from '@mui/material';
import {
  PageContainer,
  InputV2,
  AutocompleteV,
  LoadingPage,
  WalletOrCredit,
  CustomCaptchaComponent,
  InputCurrency
} from 'components';
import createToast from 'components/Toast/Toast';
import { useForm, Controller } from 'react-hook-form';
import { makeStyles } from '@mui/styles';
import theme from 'theme';
import { useNavigate, useLocation } from 'react-router-dom';
import { useQuery } from 'hooks';
import WithdrawalDialog from './components/WithdrawalDialog';
import Services from '../services/ImprestServices';
import { RadioButtonIcon, RadioButtonIconFill } from 'components/CheckBox/RadioButtonIcon';
import { CheckBoxIcon, CheckBoxIconFill } from 'components/CheckBox/CheckBoxIcon';

// PODLAND_WALLET
const ImprestSettelment = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [captchaId, setCaptchaId] = useState(null);
  const [methodType, setMethodType] = useState('wallet');
  const [saveNumber, setSaveNumber] = useState(false);
  const [isDisable, setDisable] = useState({
    isPayaDisable: false,
    isCardDisable: false,
    isSatnaDisable: true,
  });

  const [list, setList] = useState({ card: [], sheba: [] });
  const [cardInfoAcc, setCardInfoAcc] = useState('SETTLEMENT_TOOL_PAYA');
  const [show, setShow] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');
  const [, setIsLoading] = useState(true);
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [role, setRole] = useState();
  const [inquiryAccount, setInquiryAccount] = useState('');
  const [enteredCaptcha, setEnteredCaptcha] = useState('');
  const methods = useForm({});
  const { handleSubmit, register, control, formState: { errors }, setValue } = methods;
  const classes = useStyles();
  const query = useQuery();
  const captchaRef = useRef();
  useEffect(() => {
    (async () => {
      try {
        setOpenBackDrop(true);
        const params = { offset: 0, size: 50 };
        const result = await Services.getSheba(params);
        const res = await Services.getCard(params);
        const dataSheba = result.result.map((res) => {
          return {
            label: res?.name ? `IR${res.shebaNumber} - ${res?.name}` : `IR${res.shebaNumber}`,
            value: res.shebaNumber,
          };
        });
        const dataCard = res.map((sh) => {
          return {
            label: sh?.name ? `${sh.number} - ${sh?.name}` : sh.number,
            value: sh.number,
          };
        });

        setList({ dataCard, dataSheba });
        setIsLoading(false);
        setOpenBackDrop(false);
      } catch (error) { }
    })();
  }, []);

  useEffect(() => {
    setRole(null);
    setValue('cards', null);
    setSaveNumber(false);
    setInquiryAccount('');
  }, [cardInfoAcc]);

  useEffect(() => {
    setCardInfoAcc('SETTLEMENT_TOOL_PAYA');
  }, []);
  useEffect(() => {
    setValue('captchaAnswer', enteredCaptcha);
  }, [enteredCaptcha]);

  const inquiry = async (inputValue) => {
    let val = inputValue.inputValue ? inputValue.inputValue : inputValue?.value;
    const isSheba =
      cardInfoAcc === 'SETTLEMENT_TOOL_PAYA' || cardInfoAcc === 'SETTLEMENT_TOOL_SATNA'
        ? true
        : false;
    if (isSheba) {
      if (val.length !== 24 || !validator.isNumeric(val)) {
        createToast('خطا', `شماره شبا مقصد باید ۲۴ عدد (بدون عبارت IR) باشد.`, 'danger');

        captchaRef?.current?.onMakeCaptcha();
        return;
      }
    } else if (val?.length !== 16 || !validator.isNumeric(val)) {
      createToast('خطا', `شماره کارت مقصد باید ۱۶ عدد و بدون کاراکتر‌های اضافی باشد.`, 'danger');
      captchaRef?.current?.onMakeCaptcha();
      return;
    }
    try {
      const res = await Services.inquiryPaymentAccountNumber(val);
      setInquiryAccount(res.result.owner);
      if (res?.result?.owner) {
        let splitFullName = String(res.result.owner).trim().split(' ');
        setValue('firstName', splitFullName[0]);
        splitFullName.shift();
        setValue('lastName', splitFullName.join(' '));
      } else {
        setValue('firstName', '');
        setValue('lastName', '');
        captchaRef?.current?.onMakeCaptcha();

        createToast('خطا', 'پاسخی دریافت نشد، لطفا نام و نام خانوادگی را وارد کنید', 'danger');
      }
      return inquiryAccount;
    } catch {
      captchaRef?.current?.onMakeCaptcha();
    }
  };

  const onSubmit = (tempData) => {
    const data = { ...tempData };
    data.cardInfoAcc = cardInfoAcc;
    const isSheba =
      cardInfoAcc === 'SETTLEMENT_TOOL_PAYA' || cardInfoAcc === 'SETTLEMENT_TOOL_SATNA';
    const target = isSheba ? 'شبا' : 'کارت';
    if (!data.cards) {
      createToast('خطا', `شماره ${target} مقصد را وارد کنید.`, 'danger');

      captchaRef?.current?.onMakeCaptcha();
      return;
    }
    const targetNumberValue = data.cards?.value ?? data.cards;
    if (isSheba) {
      if (targetNumberValue.length !== 24 || !validator.isNumeric(targetNumberValue)) {
        createToast('خطا', `شماره شبا مقصد باید ۲۴ عدد (بدون عبارت IR) باشد.`, 'danger');

        captchaRef?.current?.onMakeCaptcha();
        return;
      }
    } else if (targetNumberValue.length !== 16 || !validator.isNumeric(targetNumberValue)) {
      createToast('خطا', `شماره کارت مقصد باید ۱۶ عدد و بدون کاراکتر‌های اضافی باشد.`, 'danger');

      captchaRef?.current?.onMakeCaptcha();
      return;
    }
    if (!data.price) {
      captchaRef?.current?.onMakeCaptcha();
    } else if (
      data.cardInfoAcc !== 'SETTLEMENT_TOOL_CARD' &&
      data.cardInfoAcc !== 'SETTLEMENT_TOOL_PAYA' &&
      data.cardInfoAcc !== 'SETTLEMENT_TOOL_SATNA'
    ) {
      captchaRef?.current?.onMakeCaptcha();
    } else {
      setOpenDialog(true);
      setSelectedValue({
        guildCode: data?.guildCode?.value ?? '',
        amount: data.price,
        toolCode: data.cardInfoAcc,
        toolId: data.cards,
        uniqueId: data.uniqeId,
        captchaId,
        captchaAnswer: tempData?.captchaAnswer,
        numberName: data?.numberName,
        description: data?.description,
        paymentId: data?.paymentId,
        firstName: data?.firstName,
        lastName: data?.lastName,
      });
    }
  };

const disableItems = (amount) => {

if (amount <= 100000000) { // تا 10 میلیون تومان
    setValue('cardInfoAcc', 'SETTLEMENT_TOOL_CARD');
    setCardInfoAcc('SETTLEMENT_TOOL_CARD');

    setDisable({
      isPayaDisable: false,
      isCardDisable: false,
      isSatnaDisable: false,
    });

    if (!list?.dataCard) {
      radioGroupCashoutRef?.current?.onGetCardData();
    }

 } else if (amount > 100000000 && amount <= 2000000000) { // 10 تا 200 میلیون
    setValue('cardInfoAcc', 'SETTLEMENT_TOOL_PAYA');
    setCardInfoAcc('SETTLEMENT_TOOL_PAYA');

    setDisable({
      isPayaDisable: false,
      isCardDisable: true,
      isSatnaDisable: false,
    });

 } else if (amount > 2000000000) { // بیشتر از 200 میلیون
    setValue('cardInfoAcc', 'SETTLEMENT_TOOL_SATNA');
    setCardInfoAcc('SETTLEMENT_TOOL_SATNA');

    setDisable({
      isPayaDisable: true,
      isCardDisable: true,
      isSatnaDisable: false,
    });
  }
};

  const handleCloseDialog = () => {
    setOpenDialog(false);
    captchaRef?.current?.onMakeCaptcha();
  };

  const handleWithdrawal = (e) => {
    setShow(true);
    setCardInfoAcc(e.target.value);
    setRole({ label: '', value: '' });
  };

  const hintText =
    'شما در این قسمت می‌تواتید مبلغ مورد نظر جهت دریافت وجه را وارد و درخواست آن را ارسال نمایید. پس از تایید‌، مبلغ درخواست داده شده به حساب شما واریز خواهد شد.';
  return (
    <PageContainer
      title={'برداشت وجه'}
      description={hintText}
      breadcrumbs={constBreadCrumbsTitle.IMPREST_SETTLEMENTLIST}
      className={classes.root}
    >
      {openBackDrop ? (
        <LoadingPage />
      ) : (
        <Grid item xs={12}>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className={classes.formContent}
            noValidate
            autoComplete="off"
          >
            <WalletOrCredit
              methods={methods}
              methodType={methodType}
              setMethodType={setMethodType}
              showWalletAmount={false}
              guildNameSerivece={'guild'}
              guildLabel={'حساب ها'}
            />
            <Grid container alignItems="flex-end">
              <Grid className={classes.grid} item xs={12} md={4}>
                <InputCurrency
                  fullWidth
                  errors={errors}
                  name="price"
                  label="مبلغ"
                  control={control}
                  register={register}
                  dir="ltr"
                  decimalPlaces={0}
                  minimumValue={0}
                  rules={['required']}
                  onChangeValue={disableItems}
                />
              </Grid>
            </Grid>
            <Grid className={classes.grid} item xs={12} md={4} style={{ marginInlineStart: 8 }}>
              <Typography variant="h6">
                {' '}
                <span className={classes.require}>*</span> نوع برداشت
              </Typography>
              <Controller
                control={control}
                name="cardInfoAcc"
                onClick={handleWithdrawal}
                as={
                  <RadioGroup row value={cardInfoAcc} defaultValue={cardInfoAcc}>
                    <FormControlLabel
                      value="SETTLEMENT_TOOL_PAYA"
                      control={
                        <Radio
                          color="primary"
                          icon={<RadioButtonIcon />}
                          checkedIcon={<RadioButtonIconFill />}
                        />
                      }
                      label="پایا"
                      disabled={isDisable.isPayaDisable}
                    />
                    <FormControlLabel
                      value="SETTLEMENT_TOOL_CARD"
                      control={
                        <Radio
                          color="primary"
                          icon={<RadioButtonIcon />}
                          checkedIcon={<RadioButtonIconFill />}
                        />
                      }
                      label="کارت بانکی"
                      disabled={isDisable.isCardDisable}
                    />
                    <FormControlLabel
                      value="SETTLEMENT_TOOL_SATNA"
                      control={
                        <Radio
                          color="primary"
                          icon={<RadioButtonIcon />}
                          checkedIcon={<RadioButtonIconFill />}
                        />
                      }
                      label="ساتنا"
                      disabled={isDisable.isSatnaDisable}
                    />
                  </RadioGroup>
                }
                defaultValue="SETTLEMENT_TOOL_PAYA"
              />
            </Grid>

            {show ? (
              <>
                <Box className={classes.container}>
                  <Grid className={classes.grid} item xs={12} md={4}>
                    <AutocompleteV
                      control={control}
                      errors={errors}
                      register={register}
                      name="cards"
                      label="مقصد"
                      rules={['required']}
                      placeholder="مقصد"
                      list={
                        cardInfoAcc === 'SETTLEMENT_TOOL_CARD' ? list?.dataCard : list?.dataSheba
                      }
                      onChangeValue={(newValue) => {
                        setRole(newValue);
                        if (newValue) {
                          inquiry(newValue);
                        } else {
                          setInquiryAccount('');
                        }
                      }}
                    />
                  </Grid>
                  {role?.inputValue && inquiryAccount ? (
                    <Typography className={classes.typographyStyle}>
                      نام صاحب {cardInfoAcc === 'SETTLEMENT_TOOL_CARD' ? 'کارت' : 'شبا'}: &nbsp;
                      {inquiryAccount}
                    </Typography>
                  ) : null}
                </Box>
                <Grid className={classes.grid} item xs={12} md={4}>
                  {cardInfoAcc === 'SETTLEMENT_TOOL_CARD' && (
                    <Typography
                      variant="h6"
                      style={{
                        marginInlineStart: 4,
                        marginTop: 10,
                        marginBottom: 5,
                      }}
                    >
                      مبلغ کارمزد از حساب شما کسر خواهد شد.
                    </Typography>
                  )}
                </Grid>
              </>
            ) : (
              ''
            )}

            {role?.inputValue ? (
              <FormControlLabel
                value={saveNumber}
                control={
                  <Checkbox
                    color="primary"
                    onChange={(e) => {
                      setSaveNumber(e.target.checked);
                    }}
                    checked={saveNumber}
                    value={saveNumber}
                    icon={<CheckBoxIcon />}
                    checkedIcon={<CheckBoxIconFill />}
                  />
                }
                label={`ذخیره شماره ${cardInfoAcc === 'SETTLEMENT_TOOL_CARD' ? 'کارت' : 'شبا'
                  } در لیست ${cardInfoAcc === 'SETTLEMENT_TOOL_CARD' ? 'کارت‌ها' : 'شباها'}`}
              />
            ) : null}

            {saveNumber ? (
              <Grid item xs={12} md={4}>
                <InputV2
                  errors={errors}
                  name="numberName"
                  label={`عنوان ${cardInfoAcc === 'SETTLEMENT_TOOL_CARD' ? 'کارت' : 'شبا'}`}
                  register={register}
                  rules={['required']}
                  fullWidth
                  control={control}
                />
              </Grid>
            ) : null}
            <Grid container alignItems="flex-end">
              <Grid className={classes.grid} item xs={12} md={4}>
                <InputV2
                  fullWidth
                  errors={errors}
                  label="نام"
                  name="firstName"
                  control={control}
                  register={register}
                  rules={['required']}
                />
              </Grid>
            </Grid>
            <Grid container alignItems="flex-end">
              <Grid className={classes.grid} item xs={12} md={4}>
                <InputV2
                  fullWidth
                  errors={errors}
                  label="نام خانوادگی"
                  name="lastName"
                  control={control}
                  register={register}
                  rules={['required']}
                />
              </Grid>
            </Grid>
            <Grid className={classes.grid} item xs={12} md={4}>
              <InputV2
                fullWidth
                errors={errors}
                label="شناسه یکتا"
                name="uniqeId"
                control={control}
                rules={['isNumeric']}
                register={register}
                dir="ltr"
              />
            </Grid>

            <Grid className={classes.grid} item xs={12} md={4}>
              <InputV2
                fullWidth
                errors={errors}
                label="شناسه واریز"
                rules={['isNumeric']}
                name="paymentId"
                control={control}
                register={register}
                dir="ltr"
              />
            </Grid>

            <Grid className={classes.grid} item xs={12} md={4}>
              <InputV2
                fullWidth
                errors={errors}
                label="توضیحات"
                name="description"
                control={control}
                register={register}
              />
            </Grid>

            <Grid container>
              <InputV2
                errors={errors}
                name="captchaAnswer"
                forceValue={enteredCaptcha}
                onChangeValue={(e) => {
                  const value = e.target.value;
                  if (value.length > 5) {
                    e.preventDefault();
                    setEnteredCaptcha(value.slice(0, 5));
                  } else {
                    setEnteredCaptcha(value);
                  }
                }}
                label="کد امنیتی"
                register={register}
                englishNumber
                rules={['required', 'isNumeric']}
                fullWidth
                dir="ltr"
                control={control}
              />
              <CustomCaptchaComponent
                ref={captchaRef}
                setCaptchaId={setCaptchaId}
                setEnteredCaptcha={setEnteredCaptcha}
                pageTitle="/Imprest/SettlementList/id - تنخواه گردان - عملیات برداشت وجه از طرف"
              />
            </Grid>

            <Grid container item xs={12} justifyContent="flex-end">
              <Button
                variant="contained"
                onClick={() =>
                  navigate(query.get('origin') != 'financial' ? '/Accounts' : '/Guilds')
                }
                style={{
                  marginLeft: theme.spacing(1),
                  marginTop: theme.spacing(2),
                }}
              >
                بازگشت
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{ marginTop: theme.spacing(2) }}
              >
                ثبت درخواست تسویه
              </Button>

            </Grid>
          </form>
        </Grid>
      )}

      <WithdrawalDialog
        selectedValue={selectedValue}
        method={methodType}
        open={openDialog}
        onClose={handleCloseDialog}
        handleCredit={() => { }}
        saveAccountNumber={saveNumber}
        userId={location.state.userId}
        branchId={location.state.id}
      />
    </PageContainer>
  );
};

export default ImprestSettelment;
const useStyles = makeStyles((theme) => ({
  root: {},
  divid: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  TabPanel: {
    maxWidth: '768px',
  },
  formContent: {
    margin: theme.spacing(4, 0),
  },
  grid: {
    marginBottom: theme.spacing(0),
  },
  typographyStyle: {
    color: 'rgb(171 165 165)',
    marginLeft: '30px',
    marginTop: 'revert',
    [theme.breakpoints.down('md')]: {
      margin: '7px 0px 7px 0px',
    },
  },
  container: {
    color: 'rgb(171 165 165)',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  buttonWrapper: {
    textAlign: 'left',
  },
  require: {
    color: 'red',
  },
  destination: {
    marginBottom: theme.spacing(2),
  },
  backdrop: {
    marginTop: theme.spacing(5),
  },
  cir: {
    textAlign: 'center !important',
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(4),
  },
  progress: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  captcha: {
    maxHeight: 60,
    maxWidth: '100%',
    borderRadius: 4,
    marginInlineStart: theme.spacing(1),
    marginTop: theme.spacing(3),
  },
  bulkFileTitle: {
    fontWeight: 500,
    color: theme.palette.grey[700],
    marginTop: theme.spacing(1),
    '& a': {
      fontSize: 12,
      marginInlineStart: theme.spacing(1),
      color: theme.palette.primary.main,
      background: theme.palette.primary.light,
      padding: theme.spacing(0.5, 1.5),
      borderRadius: 20,
    },
  },
  bulkFileIcon: {
    color: theme.palette.grey[700],
    fontSize: 20,
    marginBottom: -6,
    marginInlineStart: theme.spacing(1),
    marginInlineEnd: theme.spacing(1),
  },
  radioItem: {
    border: '1px solid #dfdfdf',
    borderRadius: 8,
    padding: theme.spacing(1),
    boxSizing: 'border-box',
    display: 'block',
    marginInlineEnd: theme.spacing(0),
    marginInlineStart: 0,
    transition: 'all .1s ease-in',
    '&.active': {
      background: '#eceff1',
      borderColor: '#2B3990',
    },
  },
  radioIcon: {
    color: '#2b3990',
    fontSize: 25,
    display: 'inline-block',
    marginBottom: -8.5,
    marginInlineEnd: theme.spacing(1),
  },
  radioText: {
    color: '#2b3940',
    fontSize: 14,
    textOverflow: 'ellipsis',
    overflowWrap: 'break-word',
    whiteSpace: 'nowrap',
    maxWidth: 'calc(100% - 80px)',
    overflow: 'hidden',
    display: 'inline-flex',
  },
  radioCircle: {
    color: '#78909c',
  },
  infoIcon: {
    fontSize: '20px',
    marginBottom: theme.spacing(-0.8),
    marginInlineStart: theme.spacing(1),
    color: theme.palette.grey[500],
    cursor: 'pointer',
  },
  balanceBox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0.8),
    background: '#eceff1',
    border: '1px solid #2B3990',
    padding: theme.spacing(1.5),
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.09)',
    borderRadius: 8,
    backgroundImage: 'url(/images/riyal.svg)',
    backgroundPosition: '-19px center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 75%',
  },
  balanceTitle: {
    color: '#263238',
    fontSize: 14,
    fontWeight: 'bold',
  },
  balancePrice: {
    color: '#263238',
    fontSize: 24,
    fontWeight: 'normal',
  },
  balancePriceText: {
    color: '#263238',
    fontSize: 12,
    fontWeight: 'normal',
    marginTop: theme.spacing(0.5),
  },
  currencyText: {
    fontSize: 15,
    paddingInlineStart: theme.spacing(1),
  },
}));
